import React from "react";
import { Link, useParams, useOutletContext } from "react-router-dom";
import MpgErrorDialog from "../../../../../common/dialog/MpgErrorDialog";
import EditClientAccPD from "./EditClientAccPD";
import { useGetClientAccPDByIdQuery } from "../../../../../reactQueries/AppApi/rqHooksForClientAccProgrammeDescriptor";

const EditClientAccPDHome = () => {
  let { id } = useParams();
  const {
    data: dataById,
    isError: isErrorOnClientAccPDById,
    isFetching: isFetchingOnClientAccPDById,
    isSuccess: isSuccessOnClientAccPDById,
    error: errorOnClientAccPDById,
  } = useGetClientAccPDByIdQuery({ clientAccountId: id });

  const resourcesCMSData = useOutletContext();

  const fetchCommonCMSLabel = (key) => {
    if (resourcesCMSData && resourcesCMSData?.pageContent["CommonComponent"]) {
        const commonCMSDataLabel = resourcesCMSData.pageContent["CommonComponent"];
        return returnLabel(commonCMSDataLabel?.Labels, key)
    }
    return '';
  }

  const returnLabel = (labelArray, key) => {
    if (labelArray.length > 0 && key) {
        return labelArray.find((x) => x.Key === key)?.Phrase || '';
    }
    return '';
  }

  return (
    <div>
      {
        !!isFetchingOnClientAccPDById && fetchCommonCMSLabel('Common.Waitloading') //"Wait, Loading...."
      }
      {!!isSuccessOnClientAccPDById && (
        <EditClientAccPD clientAccPDById={dataById} />
      )}

      <MpgErrorDialog
        open={!!isErrorOnClientAccPDById}
      />
    </div>
  );
};

export default EditClientAccPDHome;
